module.exports = __webpack_public_path__ + "img/iotwise1.d614a5f6.png";